
export class CustomConstants {

    // Version
    public static ADMIN_SOFTWARE_VERSION: string = "v0.0.1";

    // Admin
    public static ADMIN_SOFTWARE_NAME: string = "Terraform";
    public static ADMIN_SOFTWARE_ENDPOINT: string = "https://admin.app.terraformtillage.com";
    public static MONITORING_SOFTWARE_URL: string = "https://app.terraformtillage.com";

    // Backend
    public static API_ENDPOINT: string = "https://us-central1-terraform-tillage.cloudfunctions.net/v2";
    public static SERVER_UIDS: string[] = [
        "jas-data-server",
        "jas-schedule-server",
        "jas-billing-server",
        "jot-server"
    ];

    // (Automatic billing)
    public static STRIPE_OEM_CONNECT_ID: string = "";

    // Return the stripe fee amount for a given price ID (100 = $1)
    public static getJASFeeForPriceID(priceID: string | null): number {
        // Default to none
        //console.error("No JAS fee for unknown price ID: " + priceID);
        return 0;
    }

}
